import {BaseApiConfig} from "@/Service/Api/V1/BaseApiConfig";
import {NotificationsApi} from "@/Stub/V1";

export const notificationsApiClient = new NotificationsApi(BaseApiConfig);
